export default __webpack_public_path__ + "static/media/Md-Sabeel.fe40cd57.pdf";